import React from "react";
import DfbImage from "../ui-kit/dfb_image";
import DfbHeadline from "../ui-kit/dfb_headline";
import DfbButton from "../ui-kit/dfb_button";
import { Transformation } from "cloudinary-react";
import Section from "./section"

const MHeroSlider = props => {
  return (
    <Section
      baseClass="m-Hero m-Hero--slider"
      data={props.data}
    >
      <div
        className="dfb-Slider dfb-Slider--noMargin m-Hero-slider"
        data-transition="slide"
        data-autoplay
        data-indicators
        data-drag
        data-controls
        role="region"
        tabIndex={0}
      >
        <div className="dfb-Slider-slider">
          <ul className="dfb-Slider-slides">
            {props.data.slides.map((item, index) => (
              <li
                className={
                  "dfb-Slider-slideItem m-Hero-item " +
                  (index === 0 ? "is-open" : null)
                }
                data-index={index}
                key={`hero-slide-${index}`}
              >
                <div className="m-Hero-itemImage">
                  <DfbImage
                    image={item.image}
                    aspect_ratio="3:1"
                    add_class="dfb-Image--overlay dfb-Image--opacity55"
                  >
                    <Transformation
                      crop="fill"
                      gravity="faces:center"
                      width="1920"
                      height="1280"
                    />
                  </DfbImage>
                </div>
                <div className="m-Hero-itemContent">
                  <div className="m-Hero-itemCategory">
                    {item.kicker}
                  </div>
                  <DfbHeadline
                    headline={item.headline}
                    headline_level="h2"
                    add_class="m-Hero-itemHeadline"
                  />
                  <DfbButton
                    link={item.link}
                    text={item.link_text}
                    tagName="a"
                    add_class="u-Theme-dark m-Hero-itemButton"
                  />
                </div>
                <div className="m-Hero-itemProgressBar">
                  <div className="m-Hero-itemProgressBarFill" />
                </div>
              </li>
            ))}
          </ul>
        </div>
        <ul className="dfb-Slider-controls">
          <li className="dfb-Slider-controlElement dfb-Slider-controlElement--previous">
            <DfbButton
              icon_type="Dropdown Left"
              tagName="button"
              add_class="dfb-Slider-control dfb-Slider-control--previous"
            />
          </li>
          <li className="dfb-Slider-controlElement dfb-Slider-controlElement--next">
            <DfbButton
              icon_type="Dropdown Right"
              tagName="button"
              add_class="dfb-Slider-control dfb-Slider-control--next"
            />
          </li>
        </ul>
      </div>
    </Section>
  )
}

export default MHeroSlider
